export const variables = {
    seleccionesUrl: "https://www.selecciones.com.ar",
    apiUrl: "https://www.selecciones.com.ar/api",
    fsStore: 'selecciones.onfastspring.com/popup-selecciones'
  }
  